import { useState, forwardRef } from "react";
import DynamicIcon from "./dynamic-icon";
import Tooltips from "./tooltip";

const Input = forwardRef(
  (
    { onChange, value, additionalclasses, inputInfo, hasValue, inputClass, disabled, ...rest },
    ref
  ) => {
    const [inputValue, setInputValue] = useState("");

    const label = rest.label;

    if (label?.length > 64) throw new Error(`Label "${label}" is too long`);

    const id = label && `_${label.replace(/\s+/g, "-").toLowerCase()}`;

    function handleInput(e) {
      setInputValue(e.target.value);
      onChange && onChange(e);
    }

    function setFocus() {
      if (ref && ref.current) {
        ref.current.focus();
      }
    }

    return (
      <div onClick={() => setFocus()} className="grid relative">
        <label
          htmlFor={id}
          className="custom-text-grey-500  text-[14px] poppins-medium pb-1 empty:hidden text-left flex items-center gap-[4px]"
        >
          {label}
          {rest.hasInfo && (
            <Tooltips command={rest.tooltip.command} content={rest.tooltip.content} position={rest.tooltip ? rest.tooltip.position : null} additionalTooltipClasses='!max-w-[300px]'>
              <DynamicIcon name='info' size={12} color={`custom-text-grey-500`} />
            </Tooltips>
          )}
        </label>
        <div className={`max-w-[400px] relative pr-[16px] h-[48px] flex items-center gap-[4px] w-full poppins-light rounded-lg custom-text-grey-500 custom-bg-white-50 disabled:custom-bg-white-100 ${additionalclasses}`}>
          <input
            className={
              `${inputClass} !outline-none !bg-[transparent] !disabled:cursor-not-allowed h-full w-full rounded-lg px-4 `
            }
            type={rest.type || "text"}
            ref={ref}
            onChange={handleInput}
            value={value || inputValue}
            disabled={disabled}
            id={id}
            {...rest}
          />
          <div className="flex items-center gap-[8px]">
            {rest.showCheckmark && <DynamicIcon name="check" size={16} />}
            {rest.surfix && <p className="text-[12px] lg:text-[14px] poppins-bold text-right custom-text-grey-900 whitespace-nowrap">{rest.surfix}</p>}
          </div>
        </div>
        <span className="custom-text-grey-500  text-[9px] empty:hidden absolute -bottom-4">
          {inputInfo}
        </span>
      </div>
    );
  }
);

Input.displayName = "Input";

export default Input;
